import {CONFIG} from "../../config";
import axios from "axios";

async function DeleteUserQuery(id) {
    const location = CONFIG.API_URL + "user/delete/" + id;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.delete(location, settings);
    } catch (e) {
        return e;
    }
}

export default DeleteUserQuery;